export const theme = {
  colors: {
    primary: '#E94B4A',
    secondary: '#16057C',
  },
}
